


// Working with millisecond epoch timestamps because there are some convenience functions for that in php

export const minutes = (v: number) => {
  return v * 60 * 1000;
}

export const seconds = (v: number) => {
  return v * 1000;
}